import React from 'react';
import API from 'shared/constants/api';
import DESCRIPTION from 'shared/constants/seoDescriptions';
import TITLE from 'shared/constants/seoTitles';
import HEADER from 'shared/constants/seoHeaders';
import queryString from 'query-string';
import { targeting } from 'shared/modules';
import { setLocation } from 'shared/actions/globals';
import { clearSelected, setTransportResults } from 'shared/actions/searchForm';
import SECONDARY_LOCATIONS from 'shared/constants/json/secondaryLocations.json';
import CITIES from 'shared/constants/json/cities.json';
import REGIONS_CITIES from 'shared/constants/json/regions&cities.json';
import { toLocalized } from 'shared/helpers/locale';
import Moto from './Moto';
import Layout from '../../components/Layout';

const CURRENT_TRANSPORT_ID = 131;
async function action(data) {
  const { fetch, store, params, translate } = data;
  const { globals, searchForm } = store.getState();
  const { location, locale } = globals;

  const { locationSlug } = params;

  if (location && location.is_country) {
    store.dispatch(setLocation(null));
  }

  if (
    location &&
    !locationSlug &&
    [...CITIES, ...SECONDARY_LOCATIONS, ...REGIONS_CITIES].find(item => item.id === location.id)
  ) {
    return {
      redirect: toLocalized(`/moto/${location.slug}/`.replace(/\/\//g, '/'), locale),
    };
  }

  if (searchForm.selected.transport && searchForm.selected.transport.id !== CURRENT_TRANSPORT_ID) {
    store.dispatch(clearSelected());
  }

  const routeLocation = locationSlug
    ? [...CITIES, ...SECONDARY_LOCATIONS, ...REGIONS_CITIES].find(
        item => item.slug === locationSlug,
      )
    : null;

  if (locationSlug && !routeLocation) {
    return null;
  }

  if (routeLocation && (!globals.location || globals.location.slug !== locationSlug)) {
    store.dispatch(setLocation(routeLocation));
  }

  const brands = await fetch(
    `${API.ADVERT.MAKES_COUNT}?${queryString.stringify({
      transport: CURRENT_TRANSPORT_ID,
      ...(routeLocation ? { location: routeLocation.id } : {}),
      ...(!routeLocation && location ? { location: location.id } : {}),
    })}`,
  ).then(r => r.json());

  const titleLocation =
    routeLocation && routeLocation.where ? routeLocation.where[globals.locale] : undefined;

  const metaParams = {
    transport: 'moto',
    location: (routeLocation && routeLocation.title) || (location && location.title),
    locationWhere:
      (routeLocation && routeLocation.where && routeLocation.where[locale]) ||
      (location && location.title),
  };
  const headerLocation = (routeLocation && routeLocation.title) || (location && location.title);
  const headerLocationWhere =
    (routeLocation && routeLocation.where && routeLocation.where[locale]) ||
    (location && location.title);

  const description = DESCRIPTION.SEARCH.moto(metaParams, translate);
  const title = TITLE.SEARCH.moto(metaParams, translate);
  const metaHeader = HEADER.MOTO(
    { location: headerLocation, locationWhere: headerLocationWhere },
    translate,
  );
  await targeting(data);
  await store.dispatch(setTransportResults(CURRENT_TRANSPORT_ID));

  return {
    chunks: ['moto'],
    title,
    description,
    metaHeader,
    routeName: 'moto',
    shouldSetNoIndex: false,
    shouldSetIndex: true,
    component: (
      <Layout withBranding>
        <Moto
          title={metaHeader}
          titleLocation={titleLocation}
          brands={brands}
          routeLocation={routeLocation}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/moto/index.js